// Optimized Home Component
import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  Suspense,
} from "react";
import MarqueeImageComponent from "./MembersBirthdays";
import { Modal } from "react-bootstrap";
import "./Home.css";
import FacilityGrid from "./Facilitygrid.jsx";
import FacilityGridNew from "./FacilitygridNew.jsx";
import PopupImage from "../Images/16.JPG";
import { LazyLoadImage } from "react-lazy-load-image-component";
import styled from "styled-components";
import { Chip, Stack, Typography } from "@mui/material";
// import { Typography } from "antd";

// Dynamically import heavy components
const RatesAndBooking = React.lazy(() => import("./Ratesandbooking"));

export default function Home() {
  const [showPopup, setShowPopup] = useState(false);
  const [showHeroVideo, setShowHeroVideo] = useState(false);

  // Memoize YouTube embed URL
  const youTubeEmbedUrl = useMemo(
    () =>
      "https://www.youtube.com/embed/21-4Pj3_a44?autoplay=1&mute=1&controls=1&loop=1&playlist=21-4Pj3_a44&disablekb=1&modestbranding=1&rel=0&showinfo=0",
    []
  );

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleClosePopup = useCallback(() => setShowPopup(false), []);

  useEffect(() => {
    scrollToTop();
    setShowPopup(true); // show popup on mount
  }, [scrollToTop]);

  // ⏳ Auto-close after 10 sec
  useEffect(() => {
    let timer;
    if (showPopup) {
      timer = setTimeout(() => {
        handleClosePopup();
      }, 10000);
    }
    return () => clearTimeout(timer);
  }, [showPopup, handleClosePopup]);

  // Trigger video loading after initial render
  useEffect(() => {
    const timer = setTimeout(() => setShowHeroVideo(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const Container = styled.div`
    height: fit-content;

    @media (max-width: 1024px) {
      height: 38vh;
    }
  `;

  const heroBanner = useMemo(
    () => (
      <Container className="slider-container">
        <div
          className="slider-heading"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "100%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
            color: "#fff",
            textAlign: "center",
            // padding: "0.5rem",
          }}
        >
          <h3>
            WEL
            <span style={{ color: "rgb(85,47,54)" }}>COME </span> TO{" "}
            <span style={{ color: "rgb(85,47,54)" }}>JAICLUB</span>
          </h3>
          <h4>Join the Crew, Experience the Difference</h4>
          <p
            style={{
              fontSize: "16px",
              letterSpacing: "10px",
              fontWeight: "300",
              fontFamily: "Dosis, sans-serif",
              textShadow: "1px 1px 8px rgba(0,0,0,0.5)",
            }}
          >
            Connect, Celebrate, Thrive
          </p>
        </div>

        <div className="video-container">
          {/* Only load video when visible */}
          {showHeroVideo && (
            <iframe
              width="100%"
              height="100%"
              src={youTubeEmbedUrl}
              title="YouTube video player"
              frameBorder="0"
              allowFullScreen
              loading="lazy"
            />
          )}
        </div>
      </Container>
    ),
    [youTubeEmbedUrl, showHeroVideo]
  );

  const clubDescription = useMemo(
    () => (
      <div className="container mt-5 ">
        <div className="row justify-content-center">
          <div className="col-lg-10 ">
            <h3
              style={{
                fontSize: "2.3em",
                textAlign: "center",
                fontFamily: "Dosis, sans-serif",
                color: "rgb(85,47,54)",
                fontWeight: "600",
              }}
            >
              A place where time forgets to rush
            </h3>

            <p
              style={{
                fontSize: "16px",
                fontWeight: "300",
                letterSpacing: "0.5px",
                color: "rgba(0, 0, 0, 0.7)",
                marginTop: "1.5rem",
                lineHeight: "2em",
                textAlign: "justify",
                fontFamily: "Open Sans, sans-serif",
                padding: "7px",
              }}
            >
              Founded in 1946 by Late Shri RN Day,{" "}
              <span style={{ color: "#DC143C" }}>Jai Club</span> is one of the
              most famous and oldest clubs in Jaipur that is spread across a
              sprawling area of seven acres. This recreational club offers a
              wide array of entertainment options and boasts of the latest
              infrastructure and maintains full-fledged facilities for sports
              like tennis, besides a health club. It has developed into a
              multi-dimensional club offering a multitude of facilities that
              include gym, swimming facility, and sports and yoga club. A cafe
              and restaurant are also available within the premises of{" "}
              <span style={{ color: "#DC143C" }}>Jai Club</span>, which has more
              than 2200 members on roll. It has facilities for recreation /
              sports, dining and lodging. The gymnasium has facilities well
              suited for body fitness. Indoor and outdoor games such as
              badminton, billiards, cards, tennis and cricket can be played.
              There is a children's pool and a swimming pool with adjoining
              dressing rooms.
            </p>
          </div>
        </div>
      </div>
    ),
    []
  );

  // 🟢 Memoized Popup JSX
  const popupModal = useMemo(
    () => (
      <Modal show={showPopup} onHide={handleClosePopup} centered size="lg">
        <Modal.Header closeButton style={{ padding: "5px" }}>
          <h5 className="fw-bold text-center w-100">Management Committee</h5>
        </Modal.Header>
        <Modal.Body className="text-center">
          <LazyLoadImage
            src={PopupImage}
            alt="Popup"
            style={{ maxWidth: "100%", borderRadius: "10px" }}
          />
          <Stack
            direction="row"
            spacing={1}
            useFlexGap
            sx={{ mt: 1, flexWrap: "wrap" }}
          >
            <Typography
              sx={{ fontWeight: 800, fontSize: "15px", color: "#240505ff" }}
            >
              Sitting - OFFICE BEARERS -
            </Typography>
            <Chip
              label={
                <span>
                  DR. MANISHA JAIN{" "}
                  <span style={{ color: "#195eb8ff" }}>
                    (Jt. Secretary - Sports)
                  </span>
                </span>
              }
              variant="outlined"
              size="small"
            />
            <Chip
              label={
                <span>
                  CA ASHOK KUMAR JAIN (HARKAWAT){" "}
                  <span style={{ color: "#195eb8ff" }}>
                    (Treasurer)
                  </span>
                </span>
              }
              variant="outlined"
              size="small"
            />
            <Chip
              label={
                <span>
                  SANJAY BHANSALI{" "}
                  <span style={{ color: "#195eb8ff" }}>
                    (Hony. Secretary)
                  </span>
                </span>
              }
              variant="outlined"
              size="small"
            />
            <Chip
              label={
                <span>
                  DR. HARI OM BOMB{" "}
                  <span style={{ color: "#195eb8ff" }}>
                    (President)
                  </span>
                </span>
              }
              variant="outlined"
              size="small"
            />
            <Chip
              label={
                <span>
                  RAJEEV NAGORI{" "}
                  <span style={{ color: "#195eb8ff" }}>
                    (Vice-President)
                  </span>
                </span>
              }
              variant="outlined"
              size="small"
            />
            <Chip
              label={
                <span>
                  VIKAS JAIN{" "}
                  <span style={{ color: "#195eb8ff" }}>
                    (Jt. Secretary)
                  </span>
                </span>
              }
              variant="outlined"
              size="small"
            />
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            useFlexGap
            sx={{ mt: 2, flexWrap: "wrap" }}
          >
            <Typography
              sx={{ fontWeight: 800, fontSize: "15px", color: "#240505ff" }}
            >
              Standing - Executive Members -
            </Typography>
            <Chip label="ROBIN KALA" variant="outlined" size="small" />
            <Chip
              label="PUSHPENDRA SINGH RATHORE"
              variant="outlined"
              size="small"
            />
            <Chip label="DHIRAJ VIJAYVERGIA" variant="outlined" size="small" />
            <Chip label="SURENDRA BHANDARI" variant="outlined" size="small" />
            <Chip label="SANJEEV JAIN" variant="outlined" size="small" />
            {/* <Chip
              label={
                <span>
                  DASOT MANOJ{" "}
                  <span style={{ color: "#195eb8ff" }}>
                    (Ex-Officio)
                  </span>
                </span>
              }
              variant="outlined"
              size="small"
            /> */}
            <Chip label="DR.TARUN PATNI" variant="outlined" size="small" />
            <Chip label="AMIYA KALA" variant="outlined" size="small" />
            <Chip label="SIDDHARTHA SHARMA" variant="outlined" size="small" />
          </Stack>
        </Modal.Body>
      </Modal>
    ),
    [showPopup, handleClosePopup]
  );

  return (
    <div>
      {heroBanner}
      {clubDescription}

      <div className="d-flex justify-content-center">
        <FacilityGridNew />
      </div>
      {/* <div className="d-flex justify-content-center">
        <FacilityGrid />
      </div> */}

      <div className="row">
        <Suspense fallback={<div>Loading...</div>}>
          <RatesAndBooking />
        </Suspense>
      </div>

      <MarqueeImageComponent />
      {popupModal}
    </div>
  );
}
